import * as React from "react";
import { useDataProvider } from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import ServiceableServiceLevelBarChartComponent from "./ServiceableServiceLevelBarChartComponent";
import ServiceableServiceLevelGridComponent from "./ServiceableServiceLevelGridComponent";
import ServiceableServiceLevelPieChartComponent from "./ServiceableServiceLevelPieChartComponent";
import useAiInsight from "../../../Components/AiAssistant/useAiInsight";
import { buildAiBaseParams } from "../../../Components/AiAssistant/buildAiBaseParams";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const ServiceableServiceLevelComponent = ({ filterParams, contractList }) => {
  const dataProvider = useDataProvider();
  const [data, setData] = React.useState([] as any);
  const resourceEndpoint = "/pbhrequestserviceables/cockpit/serviceableservicelevel";

  const insightParams = React.useMemo(() => {
    if (!data.length) return null;
    const totalOnTime = data.reduce((s: number, item: any) => s + (item.onTime ?? 0), 0);
    const totalDelayed = data.reduce((s: number, item: any) => s + (item.delayed ?? 0), 0);
    const total = totalOnTime + totalDelayed;
    return {
      ...buildAiBaseParams(filterParams),
      totalOnTime: totalOnTime.toString(),
      totalDelayed: totalDelayed.toString(),
      serviceLevelRate: total > 0 ? ((totalOnTime / total) * 100).toFixed(2) : "0",
    };
  }, [filterParams, data]);
  useAiInsight("serviceableservicelevelcomponent", insightParams);

  React.useEffect(() => {
    GetServiceableServiceLevelData();
  }, [filterParams, filterParams?.contractId !== 0]);

  const ProcessData = rawData => {
    // 1. İlk filtreleme: onTime + delayed > 0 olanlar
    const filteredData = rawData.filter(item => item.onTime + item.delayed > 0);

    // 2. cockpitServiceableServiceLevelDetail içerisindeki her item'a contractName ekle
    const processedData = filteredData.map(item => {
      const detailsWithContractName = item.cockpitServiceableServiceLevelDetail?.map(detail => {
        // contractId ile contractList'ten contractName bul
        const contract = contractList?.find(c => c.contractId === detail.contractId);
        const contractName = contract?.contractName || "Unknown";

        return {
          ...detail,
          contractName: contractName, // contractName alanı eklendi
        };
      });

      // Ana item'a da contractName ekle (excel export için)
      const mainContract = contractList?.find(c => c.contractId === item.contractId);
      const mainContractName = mainContract?.contractName || "Unknown";

      return {
        ...item,
        contractName: mainContractName,
        cockpitServiceableServiceLevelDetail: detailsWithContractName,
      };
    });

    return processedData;
  };

  const GetServiceableServiceLevelData = async () => {
    await dataProvider
      .getList(resourceEndpoint, {
        pagination: { page: 1, perPage: 999999 },
        sort: { field: "id", order: "ASC" },
        filter: filterParams,
      })
      .then(({ data }) => {
        const processedData = ProcessData(data);
        setData(processedData);
      })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" align="center">
        Serviceable Service Level
      </Typography>
      <Grid {...gridContainerProps} alignItems={"flex-start"}>
        <Grid item xs={12} sm={5}>
          <ServiceableServiceLevelBarChartComponent data={data} />
        </Grid>
        <Grid item xs={12} sm={5}>
          <ServiceableServiceLevelPieChartComponent data={data} />
        </Grid>
        <Grid item xs={12}>
          <ServiceableServiceLevelGridComponent data={data} />
        </Grid>
      </Grid>
    </>
  );
};

export default ServiceableServiceLevelComponent;
